import { useEffect } from "react";
import { useState, useContext, createContext } from "react";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import { getAuth } from "firebase/auth";
import { toast } from "react-toastify";
import { addGroup, getGroups, joinGroup, updateGroup } from "../firebase/controller/community";

const GroupContext = createContext();

export function useGroup(){
    return useContext(GroupContext);
}

export function GroupProvider({ children }) {
    const [loading, setLoading] = useState(false);
    const [ groups, setGroups] = useState([]);
    const [ myGroups, setMyGroups] = useState([]); 
    const [ loadMyGroups, setLoadMyGroups ] = useState(false);
    const [ loader, setLoader] = useState(false);
    const [ openedGroup, setOpenedGroup ] = useState();

    const dispatch = useDispatch();

    const getgroups = async () => {
        try {
            setLoading(true);
            const res = await getGroups(groups.length - 1, false);
            setGroups([...groups, ...res]);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            console.log(message);
            toast.error(message);
            setLoading(false);   
        }
    }

    const getmygroups = async () => {
        try {
            setLoading(true);
            const res = await getGroups(myGroups.length - 1, true);
            setMyGroups([...myGroups, ...res]);
            setLoading(false);
        } catch (error) {
            const message = error.message;
            console.log(message);
            toast.error(message);
            setLoading(false);
        }
    }

    const addgroup = async (data) => {
        try {
            const res = await addGroup({ ...data });
            res && toast.success("group created successfully.");
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const updategroup = async (data, groupId) => {
        try {
            const res = await updateGroup(data, groupId);
            res && toast.success("group updated successful.");
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            setLoading(false);
        }
    }

    const joingroup = async (gdata, id) => {
        try {
            const res = await joinGroup(gdata, id);
            res && toast.success("joined successfully.");
            setLoading(false);
        } catch (error) {
            const message = error.message;
            toast.error(message);
            console.log(message);
            setLoading(false);
        }
    }


    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged((user) => {
            if (user) {
                if(!loadMyGroups) {
                    setMyGroups([]);
                    getgroups();
                }else{
                    setGroups([]);
                    getmygroups()
                }
            }
        });
        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadMyGroups]);


    useEffect(() => {
        if (loading || loader) dispatch(openModal())
        if (!loading && !loader) dispatch(closeModal())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, setLoading])

    const values = {
        loading,
        groups,
        myGroups,
        setLoader,
        updategroup,
        setOpenedGroup,
        openedGroup,
        setLoadMyGroups,
        addgroup,
        joingroup,
        loadMyGroups,
        setLoading,
    }
    return <GroupContext.Provider value={values}>
        {children}
    </GroupContext.Provider>
}